<template>
  <TopBanner :warningColor="warningColor">
    <div class="flex flex-col items-center">
      <IconLabel v-if="warningColor" icon="varning">
        <template v-if="individStore.individ.data?.hasSkyddadIdentitet">Skyddad identitet</template>
        <template v-else-if="individStore.individ.data?.isAvliden">Avliden</template>
        <template v-else-if="individStore.individ.data?.isAvtalatAnstalld">Anställd på Avtalat</template>
      </IconLabel>
      <TitleText>{{ formattedName }}</TitleText>
      <LabelItem>{{
        personnummerWithDash12Digits(individStore.individ.data?.personnummer)
      }}</LabelItem>
      <IdentifiedTag :identified="individStore.verification.isVerified"
        :manuallyIdentified="individStore.verification.isManuallyVerified"
        :isLoading="individStore.verification.isAuthenticating" />
    </div>
    <div class="absolute right-none z-20" id="bank-id-button">
      <BankId :personnummer="individStore.individ.data?.personnummer" />
    </div>
  </TopBanner>
</template>

<script setup lang="ts">
import { computed } from "vue";

import {
  IconLabel,
  IdentifiedTag,
  LabelItem,
  TitleText,
  TopBanner,
} from "@/components/top-banner";
import BankId from "@/components/verification/BankID.vue";
import { useIndividStore } from "@/stores";
import {
  formatIndividFullName,
  personnummerWithDash12Digits,
} from "@/common/formatters";

const individStore = useIndividStore();

const warningColor = computed(() => {
  if (individStore.individ.data?.isAvtalatAnstalld) {
    return "pink";
  }
  if (individStore.individ.data?.hasSkyddadIdentitet || individStore.individ.data?.isAvliden) {
    return "red";
  }
  return undefined;
});
const formattedName = computed(() =>
  formatIndividFullName(individStore.individ.data),
);
</script>
